import React from 'react';
import { ParentCounselorDashboard } from '../components/collaboration/ParentCounselorDashboard';

export const FamilyCollaborationPage: React.FC = () => {
  return <ParentCounselorDashboard />;
};